<template>
  <main>
    <div class="content">
      <h1>Task Block</h1>
      <h2>Pet food &amp; Accessories</h2>
      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.</p>
      <div class="cta">
        <button class="btn btn-fill" @click="$emit('show-auth','login')">登录</button>
        <button v-if="registerEnabled" class="btn btn-outline" @click="$emit('show-auth','register')">注册</button>
      </div>
    </div>

    <div class="illustration">
      <!-- illustration placeholder -->
    </div>
  </main>
</template>

<script>
export default {
  name: 'HomeContent',
  props: {
    // 注册开关（来自后端 system_settings）：关闭时隐藏注册入口，避免点进去才发现注册不了
    registerEnabled: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
main{
  position:relative;
  display:flex;
  align-items:center;
  flex:1;
  min-height:0;
  margin-top:0.625rem;
}

.illustration{
  position:relative;
  width:46%;
  display:flex;
  align-items:center;
  justify-content:center;
}

.content{
  position:relative;
  width:54%;
  padding-left:1.25rem;
  text-align:left !important;
}
.content h1{
  font-size:3.5rem;
  color:var(--navy);
  font-weight:800;
  letter-spacing:0.0625rem;
  line-height:1;
}
.content h2{
  font-size:1.25rem;
  color:var(--accent-orange);
  font-weight:700;
  margin-top:0.5rem;
  margin-bottom:1.125rem;
}
.content p{
  font-size:0.8125rem;
  color:#8a7a6c;
  line-height:1.7;
  max-width:380px;
  margin-bottom:1.625rem;
}
.cta{
  display:flex;
  gap:1rem;
}
.btn{
  padding:0.813rem 1.875rem;
  border-radius:1.625rem;
  font-size:0.8125rem;
  font-weight:700;
  letter-spacing:0.03125rem;
  cursor:pointer;
  border:2px solid var(--dark-brown);
  font-family:inherit;
}
.btn-fill{
  background:#558b2f;
  color:#fff;
  border-color:#558b2f;
}
.btn-outline{
  background:transparent;
  color:#558b2f;
  border-color:#558b2f;
}

@media (max-width:800px){
  main{flex-direction:column;}
  .illustration,.content{width:100%;}
  .content{padding-left:0;text-align:center;margin-top:1.25rem;}
  .content p{margin-left:auto;margin-right:auto;}
  .cta{justify-content:center;}
  .content h1{font-size:2.5rem;}
}
</style>
